var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM15.6171 10.7071C16.0076 10.3166 16.0076 9.68342 15.6171 9.29289C15.2266 8.90237 14.5934 8.90237 14.2029 9.29289L10.61 12.8858L9.70711 11.9829C9.31658 11.5924 8.68342 11.5924 8.29289 11.9829C7.90237 12.3734 7.90237 13.0066 8.29289 13.3971L9.90289 15.0071C10.2934 15.3976 10.9266 15.3976 11.3171 15.0071L15.6171 10.7071Z",
    fill: "#55C377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.ed6be9e4362970dc39d4368c7a9da17c.svg";
export { ForwardRef as ReactComponent };